import { writable } from 'svelte/store'


const createAlert = () => {
  const alertDefault = { 
    active: false, 
    message: '', 
    type: '', 
    timeOut: 0
  }
  
  const { subscribe, set } = writable(alertDefault)
  
  /**
   * Set the alert component
   * 
   * @param {Object} objectParam
   * @param {String} objectParam.message
   * @param {"error"|"info"|"successful"} objectParam.type
   * @param {number} [objectParam.timeOut]
   */
  const newAlert = ({ message = '', type = 'error', timeOut = 2500 }) =>
    set({ message, type, timeOut, active: true })
  
  const removeAlert = () => set(alertDefault)
  
  return { newAlert, removeAlert, subscribe }
}

export const alert = createAlert()